/**
 * audit-mode · shared helpers for the Phase 1 verification-only rollout.
 *
 * companies.settings.dashboard_mode === "audit" is the canonical flag. When
 * a tenant is in audit mode, only verification surfaces should render; every
 * other /dash/* path either redirects to /dash/verify (HomeGate, AuditModeRedirect)
 * or hides via PhaseGate.
 *
 * The "safe mode" escape hatch (?safe=1 once, then sticky in sessionStorage)
 * exists so a pilot can recover if /dash/verify itself crashes. Sticky so it
 * survives in-app navigation; sessionStorage-scoped so it auto-clears on logout
 * or browser restart and never leaks into a new admin's session.
 */

const SAFE_MODE_KEY = "cr-audit-safe";

/** True if the current URL or sticky session opts out of audit-mode redirects. */
export function isSafeModeActive(searchParams: URLSearchParams): boolean {
  if (searchParams.get("safe") === "1") {
    try { sessionStorage.setItem(SAFE_MODE_KEY, "1"); } catch { /* ignore */ }
    return true;
  }
  try { return sessionStorage.getItem(SAFE_MODE_KEY) === "1"; } catch { return false; }
}

/** Manually clear the safe-mode bypass (used on logout). */
export function clearSafeMode(): void {
  try { sessionStorage.removeItem(SAFE_MODE_KEY); } catch { /* ignore */ }
}
